export const EXPORT_API_V1014 = '/api/consumption_exports_v1014';
export const activeExportV1014 = (job) =>
  ['queued', 'running'].includes(job.status);
export const durationV1014 = (seconds) => {
  const value = Math.max(0, Math.ceil(Number(seconds) || 0));
  return `${String(Math.floor(value / 60)).padStart(2, '0')}:${String(
    value % 60
  ).padStart(2, '0')}`;
};
export const dateInputV1014 = (date) => {
  const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 16);
};
export const presetV1014 = (days, now = new Date()) => {
  const start = new Date(now);
  start.setDate(start.getDate() - days + 1);
  start.setHours(0, 0, 0, 0);
  return { start: dateInputV1014(start), end: dateInputV1014(now) };
};
export const validRangeV1014 = ({ start, end }) => {
  const from = new Date(start).getTime();
  const to = new Date(end).getTime();
  return (
    Number.isFinite(from) &&
    Number.isFinite(to) &&
    from < to &&
    to - from <= 31 * 86400000 &&
    from <= Date.now()
  );
};

const words = {
  title: ['消费清单', 'Consumption statements'],
  logs: ['日志', 'Logs'],
  special: ['专属客户日志', 'Dedicated customer logs'],
  tasks: ['导出任务', 'Export tasks'],
  history: ['导出日志列表', 'Export history'],
  create: ['创建导出清单', 'Create export'],
  modal: ['创建用户消费清单导出任务', 'Create consumption export'],
  all: ['全部任务状态', 'All statuses'],
  queued: ['排队中', 'Queued'],
  running: ['创建中', 'Creating'],
  completed: ['已完成', 'Completed'],
  failed: ['失败', 'Failed'],
  expired: ['已过期', 'Expired'],
  search: ['搜索', 'Search'],
  reset: ['重置', 'Reset'],
  id: ['ID', 'ID'],
  type: ['类型', 'Type'],
  usage: ['用户消费', 'Consumption'],
  object: ['导出对象', 'Export scope'],
  visible: ['当前可见日志', 'Visible logs'],
  range: ['时间范围', 'Time range'],
  status: ['状态', 'Status'],
  rows: ['记录条数', 'Records'],
  expiry: ['有效期', 'Expires in'],
  created: ['创建时间', 'Created'],
  actions: ['操作', 'Actions'],
  download: ['下载', 'Download'],
  remove: ['删除', 'Delete'],
  confirm: ['删除此导出任务？', 'Delete this export task?'],
  cancel: ['取消', 'Cancel'],
  close: ['关闭', 'Close'],
  dailyShort: ['按日汇总', 'Daily'],
  quick: ['快捷选择', 'Quick selection'],
  days: ['天', ' days'],
  start: ['开始时间', 'Start time'],
  end: ['结束时间', 'End time'],
  tokens: ['选择令牌', 'Select keys'],
  tokenPlaceholder: ['全部可见令牌', 'All visible keys'],
  format: ['导出表形式', 'Workbook layout'],
  key: ['按 Key 分组，每个 Key 独立 Sheet', 'Group by key, one sheet per key'],
  daily: ['按日汇总，不含明细', 'Daily summary, no detail rows'],
  submit: ['创建任务', 'Create task'],
  eta: ['预计剩余', 'Estimated remaining'],
  empty: ['暂无导出任务', 'No export tasks'],
  downloads: ['下载次数', 'Downloads'],
  lastDownload: ['最近下载', 'Last download'],
  refresh: ['刷新', 'Refresh'],
  invalidRange: [
    '请选择有效的时间范围，最多 31 天。',
    'Choose a valid date range of up to 31 days.',
  ],
  export_user_limit: [
    '已有两个未完成任务，请等待完成或删除其中一个。',
    'Two tasks are unfinished. Wait for completion or delete one.',
  ],
  export_cpu_quota_unavailable: [
    '导出暂不可用：服务器尚未配置共享 CPU 硬限制。',
    'Exports unavailable: the shared CPU hard limit is not configured.',
  ],
  export_unavailable: [
    '导出服务暂不可用，请稍后重试。',
    'Export service unavailable. Try again later.',
  ],
  export_failed: [
    '导出失败，请缩小时间范围后重试。',
    'Export failed. Retry with a smaller date range.',
  ],
  export_queue_full: [
    '导出队列已满，请稍后重试。',
    'The export queue is full. Try again later.',
  ],
  export_access_changed: [
    '日志权限已变更，请重新创建清单。',
    'Log permissions changed. Create a new export.',
  ],
  export_not_ready: [
    '文件尚未生成或已过期。',
    'The file is not ready or has expired.',
  ],
  export_invalid_token: [
    '所选令牌不可用，请重新选择。',
    'A selected key is unavailable. Select it again.',
  ],
  export_requires_local_sqlite: [
    '此部署的数据库不支持受 CPU 硬限制的导出。',
    'This database deployment does not support CPU-constrained exports.',
  ],
  export_interrupted: [
    '导出被服务重启中断，请重新创建。',
    'Export interrupted by a restart. Create a new task.',
  ],
};
export const exportTextV1014 = (language, key) =>
  words[key]?.[String(language).startsWith('en') ? 1 : 0] ||
  words.export_unavailable[String(language).startsWith('en') ? 1 : 0];
